/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_home_popular_searches_title24 = /** @type {(inputs: {}) => string} */ () => {
	return `Popular Searches`
};

const fr_home_popular_searches_title24 = /** @type {(inputs: {}) => string} */ () => {
	return `Recherches populaires`
};

const de_home_popular_searches_title24 = /** @type {(inputs: {}) => string} */ () => {
	return `Häufige Suche`
};

const es_home_popular_searches_title24 = /** @type {(inputs: {}) => string} */ () => {
	return `Búsquedas populares`
};

const it_home_popular_searches_title24 = /** @type {(inputs: {}) => string} */ () => {
	return `Ricerche popolari`
};

const ar_home_popular_searches_title24 = /** @type {(inputs: {}) => string} */ () => {
	return `عمليات البحث الشعبية`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const home_popular_searches_title24 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_popular_searches_title24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_popular_searches_title24", locale)
	if (locale === "en") return en_home_popular_searches_title24(inputs)
	if (locale === "fr") return fr_home_popular_searches_title24(inputs)
	if (locale === "de") return de_home_popular_searches_title24(inputs)
	if (locale === "es") return es_home_popular_searches_title24(inputs)
	if (locale === "it") return it_home_popular_searches_title24(inputs)
	return ar_home_popular_searches_title24(inputs)
};
export { home_popular_searches_title24 as "HOME_POPULAR_SEARCHES_TITLE" }